import React from 'react';

import CreateEditAccidentFormUi from '../CreateEditAccidentFormUi';
import { domainType } from '../../constants';

const EditAccidentDialog = (props) => {
  const {
    openDialog,
    openCreateAccidentDialog,
    onHandleInputChange,
    accident,
    submitAccident,
    isSaving,
    personnels,
    userId,
    fetchAllPersonnels,
    isLoadingPersonnel,
    allAttachments,
    onRemoveAttachment,
    loggedInUser,
    fetchExistingAttachmentsForTheAccident
  } = props;
  React.useEffect(() => {
    if (!personnels.length && openDialog === true) {
      fetchAllPersonnels(userId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openDialog]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // accident.departmentId = 1;
    // accident.branchId = branchId;

    submitAccident(accident);
  };

  const handleRemoveAttachment = (attachment) => {
    onRemoveAttachment(attachment);
  };

  const handleAttahmentChange = (value, inputFieldName) => {
    const { onUpdateAttachment } = props;
    onUpdateAttachment(value, inputFieldName);
  };

  return (
    <React.Fragment>
      <CreateEditAccidentFormUi
        openDialog={openDialog}
        isSaving={isSaving}
        onHandleInputChange={onHandleInputChange}
        openCreateAccidentDialog={openCreateAccidentDialog}
        handleSubmit={handleSubmit}
        title="Accident Detail"
        accident={accident}
        personnels={personnels}
        isLoadingPersonnel={isLoadingPersonnel}
        actionButtonText="Update"
        allAttachments={allAttachments}
        handleRemoveAttachment={handleRemoveAttachment}
        handleAttahmentChange={handleAttahmentChange}
      />
    </React.Fragment>
  );
};

export default EditAccidentDialog;
